export function getFontSize({ isLargeFont }): string {
  return isLargeFont ? '20px' : '16px';
}
